import { gql } from "@apollo/client";

export const GET_FALSE_BREAKOUTS = gql`
	query FalseBreakouts($input: FalseBreakoutsInput!) {
		falseBreakouts(input: $input) {
			createdAt
      frame
      id
      plotResultPath
      coin
		}
	}
`;
